import slugify from 'slugify'

export const classes2Object = classes => {
	const computedClasses = {}
    classes.split(' ').forEach(item => { computedClasses[item] = true })
    
    return {...computedClasses}
}


export const getRandomInt = ({min=0, max=1}={}) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}


export const getRandomBoolean = () => {
    return !!getRandomInt({max: 2})
}

export const urlFor = item => {     
    return `${item.url}/${item.id}` 
}

export const routeFor = (name, params, query) => {

    if ('slug' in params)
        params.slug = slugify(params.slug, {
            lower: true,
            strict: true
        }) || 'empty-slug'

    return {
        name,
        params,
        query
    }
}

export const validateInt = (value, defaultValue = 1) => {
    let number = parseInt(value)
    return (!isNaN(number)) ? number : defaultValue
}

export const truncate = (text, length = 50) => {
    let truncated = text 
    
    if (text.length > length)
        truncated = `${text.substring(0, length)}...`
    
    return truncated
}